<div *ngIf="!visible"><a href="#" (click)="onClickMore()">подробнее о доставке...</a></div>
<div *ngIf="visible">
  <a href="#" (click)="onClickMore()">скрыть данные о доставке</a>
  <delivery-product [product]="product" [order]="order" [period]="period" [destination]="destination"></delivery-product>
</div>
